import { BuildPath } from  '@/helpers/Paths';
import React, { useEffect, useState } from 'react';
import '../../../css/inputCount.scss'

const InputCount = (
    {label, placeholder, max, warning, set, value, textarea, icon, required, readOnly, setFormTouched}: 
    {label:string, placeholder:string, max:number, warning:number, set:(initialState: string | ((x:string) => string)) => void, value:string, textarea?:boolean, icon?:string, required?:boolean, readOnly?:boolean, setFormTouched?:(touched:boolean) => void }) => {

    const [count, setCount] = useState<number>(0);
    const [active, setActive] = useState<boolean>(false);

    useEffect(() => {
        if (value && !count){
            setCount(value.length)
        }        
    }, [value, count])

    useEffect(() => {
        if(active){
           setFormTouched(true) 
        }  
    }, [active])

    function onChange(e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>){

        if (count < max){

            // Remove breaks and trim
            const text = e.target.value.replace(/(\r\n|\n|\r)/gm, "").slice(0, max);

            setCount(text.length); 
            set(text)  
        }
    }

    function onKeyUp(e: React.KeyboardEvent<HTMLInputElement|HTMLTextAreaElement>){

        // Handle backspace when onchange wont allow any more typing
        if (count >= max && e.key === "Backspace"){
            setCount(x => x -1); 
            set((x)=> x.slice(0, -1))
        }
    }

    function outlineBuilder(){

        if (count >= max){
            return 'invalid'
        }

        if (count >= warning && count < max){
            return 'warning'
        }
    }
    
    return (

        <div className='count-container'>

            <label htmlFor={label} className='input-label'>{label} {required && <span className='required'>* (Required)</span>}</label>

            <div className={`input-count ${textarea? 'textarea' : ''} ${outlineBuilder()}`}>

                {textarea ? 
                    <textarea 
                        readOnly={readOnly}
                        id={label}
                        onChange={onChange}
                        onKeyUp={onKeyUp}
                        onFocus={() => setActive(true)}
                        onBlur={() => setActive(false)}
                        placeholder={placeholder}
                        value={value}
                        autoComplete="off"
                    />
                    :
                    <input 
                        readOnly={readOnly}
                        id={label}
                        className={`input-field ${icon ? 'has-icon': ''}`}
                        onChange={onChange} 
                        onKeyUp={onKeyUp}
                        onFocus={() => setActive(true)}
                        onBlur={() => setActive(false)}
                        placeholder={placeholder}
                        value={value}
                        type='text' 
                        autoComplete="new-password" />
                }

                {active && 
                    <div className='count'>
                        {count} / {max}
                    </div>
                }

                {icon && <img className="input-icon" src={`${BuildPath()}/images/planner/${icon}`} alt="" />}
            </div>
        </div>
        
    );
};

export default InputCount;